export const createSignatureHtml = (
	signature: string,
	options?: {
		withDivider?: boolean;
	},
) => {
	const { withDivider = false } = options || {};

	const divider = withDivider
		? `<hr style="border: none; border-top: 1px solid #e5e7eb; margin: 20px 0 16px 0;" />`
		: `<div style="margin-top: 20px;"></div>`;

	return `${divider}${signature}`;
};

export const addSignatureToContent = (
	content: string,
	signature?: string,
	options?: {
		withDivider?: boolean;
	},
) => {
	if (!signature?.trim()) return content;

	const signatureHtml = createSignatureHtml(signature, options);

	if (!content.trim()) {
		return signatureHtml;
	}

	return `${content}${signatureHtml}`;
};
